// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__MoJR-","label":"CategoryService_label__1VOCy","location":"CategoryService_location__BJMr5"};